<script lang="ts">
    import CrinkledSection from "../lib/components/CrinkledSection.svelte"
    import ProductPreview from "../lib/components/pagebuilder/product/ProductPreview.svelte"
    import PageTitle from "../lib/components/widgets/PageTitle.svelte"
    import { getProductsByCategory } from "../lib/functions/CommerceAPIs/bigCommerce/product"
    import { categories } from "../lib/store"

    export let categoryPath: string[]
    let categoryId: number = null
    let products: BKDFProduct[] = []

    function setCategoryId(categories: BigCommerceCategory[], categoryPath: string[]) {
        if (categories.length === 0) return
        for (let i = 0; i < categories.length; i++) {
            if (categories[i].path.includes(categoryPath[0])) {
                categoryPath.shift()
                if (categoryPath.length === 0) {
                    categoryId = categories[i].entityId
                    return
                }
                setCategoryId(categories[i].children, [...categoryPath])
            }
        }
    }

    setCategoryId($categories, [...categoryPath]) // Use a copy of categoryPath
    getProductsByCategory(categoryId).then((res) => {
        products = res
    })
</script>

<PageTitle title="Produkte">
    <p slot="above"></p>
    <p slot="below">{products.length} Produkte</p>
</PageTitle>
<div class="sticky-bar">
    <div class="bar"></div>
    <CrinkledSection />
</div>
<section class="wrapper">
    <ul id="products">
        {#each products as product}
            <ProductPreview product="{product}" />
        {/each}
    </ul>
</section>

<style lang="less">
    .sticky-bar {
        top: 86px;
        width: 100%;
        position: sticky;
        z-index: 1000;

        .bar {
            background-color: #0d0c0c;
            width: 100%;
            height: 3rem;
        }
    }
    .wrapper {
        #products {
            margin: 0px var(--horizontal-default-margin);
            max-width: var(--normal-max-width);
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            width: 100%;
            gap: 2.4rem;
        }
        :global #products > li {
            margin-bottom: 2.4rem;
        }
    }
</style>
